/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AuthRoles } from 'jotai/auth';
import { authService } from 'services/auth/AuthService';

const isNascarUser = () => {
  const userRoles = authService.getRolesAllRealms();
  const authorizedCupRoles: string[] = [AuthRoles.ADMIN, AuthRoles.Cup, AuthRoles.Xfinity, AuthRoles.Truck];
  return userRoles && userRoles?.some((item) => authorizedCupRoles.includes(item));
};

export default isNascarUser;
